export default __webpack_public_path__ + "static/media/windows-icon.396ac65d.svg";